import React from 'react'
import PropTypes from 'prop-types'
import {InactiveAccountIcon, PointIcon} from './index'
import {Box} from '@chakra-ui/react'

const AccountIcon = ({isActive, ...props}) => {
    if (isActive) {
        return (
            <Box position="relative">
                <InactiveAccountIcon boxSize={4} {...props} />
                <PointIcon boxSize={1} position="absolute" top={-0.5} right={-0.5} />
            </Box>
        )
    }
    return <InactiveAccountIcon boxSize={4} {...props} />
}

AccountIcon.propTypes = {
    isActive: PropTypes.bool
}

export default AccountIcon
